export const TOP_CONTENT_GET_ALL_SUCCESS = 'TOP_CONTENT_GET_ALL_SUCCESS';
export const TOP_CONTENT_GET_ALL_FAILURE = 'TOP_CONTENT_GET_ALL_FAILURE';
export const TOP_CONTENT_DATA_IS_LOADING = 'TOP_CONTENT_DATA_IS_LOADING';
